<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { ActiveQuestionReadModel } from '@Evaluation/Estimations/Domain/readmodels';
    import { DiscreteScaleLevel } from "@Scales/Model";


    @Component({
        props: {
            readModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class HostVoteEditor extends Vue
    {
        get rm(): ActiveQuestionReadModel { return this.$props.readModel as ActiveQuestionReadModel; }
        get hasScale(): boolean { return this.rm.ScaleLevels?.length > 0; }

        get scaleLevels(): DiscreteScaleLevel[] { return this.rm.ScaleLevels ?? []; }

        get value(): number | null { return this.rm.GroupVoteValue; } 
        set value(val: number | null) { this.$emit('update-value', val); } 

        get comment(): string | null { return this.rm.GroupVoteComment; } 
        set comment(val: string | null) { this.$emit('update-comment', val); } 
    } 

</script>

<template>
    <div  style="min-height: 450px;">

        <input v-if="!hasScale" type="number" v-model.number="value" class="form-control" />

        <div v-if="hasScale" class="list-group">
            <a v-for="sl in scaleLevels" class="list-group-item list-group-item-action text-center"
               @click="value = sl.Value" :class="{'bg-success': value === sl.Value, 'bg-white': value !== sl.Value}">
                <strong>{{sl.Value}} - {{sl.Name}}</strong>
                <p v-if="sl.Definition" class="mb-0">{{sl.Definition}}</p>
            </a>
        </div>

        <div class="text-center">
            <button type="button" class="btn mt-3" :class="value == null ? 'btn-success' : 'btn-outline-secondary'" @click="value = null">
                <i class="fa-regular" :class="value == null ? 'fa-square-check' : 'fa-square'"></i>
                Follow the average (default)
            </button>
        </div>
        <br />

        <div style="margin-top: 15px;">
            <textarea rows="5" v-model.trim="comment" class="form-control" placeholder="Comment..." />
        </div>
    </div>
</template>